"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var TemplatesService = (function () {
    function TemplatesService(templates, $q, $http, apiBaseUrl, $log, templateMetadata, account, environment, state, usingFeature, telemetry) {
        var _this = this;
        this.telemetry = telemetry;
        this.loadTemplates = function () {
            return $http.get("".concat(apiBaseUrl, "/template-gallery")).then(function (result) {
                templates.library = result.data;
                return templates;
            });
        };
        this.getTemplate = function (templateState) {
            if (templateState && templateState.projectId) {
                return lodash_1.default.find(templates.library, {
                    projectId: templateState.projectId,
                });
            }
        };
        this.updateTemplateState = function (onUpdateQueue) {
            return function (templateState, updateReason) {
                if (environment !== "production") {
                    $log.log(updateReason);
                }
                var path;
                cleanseTemplateState(templateState);
                if (templateState.searchTerm != null) {
                    path = "templatesSearch";
                }
                else if (templateState.dropdownItem === "my-templates") {
                    path = "templatesMy";
                }
                else if (templateState.dropdownItem === "recommended") {
                    path = "templatesRecommended";
                }
                else if (templateState.projectId || templateState.tile) {
                    path = "templatesDropdownUseCaseTileProjectId";
                }
                else if (templateState.useCase) {
                    path = "templatesDropdownUseCase";
                }
                else if (templateState.dropdownItem) {
                    path = "templatesDropdown";
                }
                else {
                    path = "templates";
                }
                state.silentlyGo(path, templateState);
                onUpdateQueue.forEach(function (onUpdate) {
                    onUpdate(templateState);
                });
            };
        };
        this.initTemplateState = function (templateState) {
            if (templateState.searchTerm != null) {
                return;
            }
            var isHardcodedFilter = templateState.dropdownItem === "my-templates" || templateState.dropdownItem === "recommended";
            if (isHardcodedFilter && templateState.useCase) {
                templateState.useCase = undefined;
            }
            else if (!templateState.dropdownItem || !templateState.useCase) {
                if (!templateState.dropdownItem) {
                    if (getAccountTemplatesLength() > 0) {
                        templateState.dropdownItem = "my-templates";
                    }
                    else {
                        templateState.dropdownItem = "recommended";
                    }
                }
                if (!isHardcodedFilter) {
                    if (!templateState.useCase) {
                        templateState.useCase = templateMetadata.useCases[0].toLowerCase();
                    }
                }
            }
            _this.telemetry.track("Template Gallery Viewed", { template_gallery_filter: templateState.dropdownItem });
        };
        var getAccountTemplatesLength = function () {
            return templates.library.filter(function (template) {
                return template.isAccountTemplate;
            }).length;
        };
        var cleanseTemplateState = function (templateState) {
            if (templateState.dropdownItem) {
                templateState.dropdownItem = lodash_1.default.kebabCase(templateState.dropdownItem);
            }
            if (templateState.useCase) {
                templateState.useCase = lodash_1.default.kebabCase(templateState.useCase);
            }
        };
    }
    return TemplatesService;
}());
exports.default = TemplatesService;
